import NoHistoryView from "../NoHistoryView";
import VehicleInfo from "./VehicleInfo";
import VehicleHistoryList from "./VehicleHistoryList";

const VehicleHistoryContainer = ({ isSucceed }) => {
  return (
    <div className="cy-history-container">
      {isSucceed ? (
        <>
          <VehicleInfo />
          <VehicleHistoryList />
        </>
      ) : (
        <NoHistoryView msg="No Vehicle History Searched..!" />
      )}
    </div>
  );
};

export default VehicleHistoryContainer;
